<template>
<el-radio-group v-model="stackTypeValue" size="small" @change="onSelectChanged">
  <el-radio-button v-if="lineChart" :label="0">势趋</el-radio-button>
  <el-radio-button :label="1">浓度——堆积</el-radio-button>
  <el-radio-button :label="2">浓度——百分比</el-radio-button>
</el-radio-group>
</template>

<script>
export default {
  name: 'StackType',
  props: {
    stackType: {
      type: Number,
      default: 1
    },
    lineChart: {
      type: Boolean
    }
  },
  data () {
    return {
      stackTypeValue: this.stackType
    }
  },
  methods: {
    onSelectChanged (stackType) {
      this.$emit('update:stackType', stackType)
      this.$emit('change', stackType)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Data/StackType.vue